import { render, staticRenderFns } from "./ChangeDocumentStatus.vue?vue&type=template&id=5b5de8aa&scoped=true&"
import script from "./ChangeDocumentStatus.vue?vue&type=script&lang=js&"
export * from "./ChangeDocumentStatus.vue?vue&type=script&lang=js&"
import style0 from "./ChangeDocumentStatus.vue?vue&type=style&index=0&id=5b5de8aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5de8aa",
  null
  
)

export default component.exports